<template>
  <div>
    <StepsContainer v-bind="$attrs">
      <template v-slot:header>
        <span class="d-md-inline">
          O que você gostaria de fazer no
        </span>
        <span class="d-md-inline primary--text">psicoplanner ?</span>
      </template>

      <template v-slot:sub-header>
        Selecione uma ou mais opções, iremos personalizar sua experiência com o
        sistema
      </template>

      <template v-slot:options>
        <v-row class="d-md-flex justify-md-center" style="width: 100%">
          <template v-for="(option, index) in options">
            <v-col class="d-flex justify-center" cols="6" md="4">
              <StepCardOption v-model="intents" style="width: 100%" :option="option" />
            </v-col>
          </template>
        </v-row>
      </template>

      <template v-slot:buttons>
        <div>
          <v-btn class="mr-4" @click="back()" rounded color="primary" outlined>
            <v-icon left> mdi-chevron-left </v-icon>
            voltar
          </v-btn>
          <v-btn class="ml-4" @click="next()" rounded color="primary" dark>
            proximo
            <v-icon right> mdi-chevron-right </v-icon>
          </v-btn>
        </div>

        <div class="d-flex justify-center pt-5">
          <v-icon v-for="i in 4" size="8px" class="pa-1" color="primary" :style="{ opacity: i <= 1 ? 1 : 0.5 }">
            mdi-circle
          </v-icon>
        </div>
      </template>
    </StepsContainer>
  </div>
</template>

<script>
import StepsContainer from "./StepsContainer.vue";
import StepCardOption from "@/components/onboarding/ui/StepCardOption.vue";

export default {
  components: {
    StepsContainer,
    StepCardOption,
  },

  data() {
    return {
      options: [
        {
          icon: "sending",
          text: "Enviar lembretes automaticamente",
          value: "lembretes",
        },
        {
          icon: "calendar",
          text: "Controlar sua agenda",
          value: "agenda",
        },
        {
          icon: "clipboard",
          text: "Organizar fichas e prontuários",
          value: "ficha_prontuario",
        },
        {
          icon: "dollar",
          text: "Gestão financeira",
          value: "gestao_financeira",
        },
        {
          icon: "selected_file",
          text: "Gestão de documentos",
          value: "gestao_documentos",
        },
      ],

      intents: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    company() {
      return this.$store.state.auth.company;
    },
  },
  methods: {
    next() {
      this.$loading.start();
      this.$http
        .update("company/company", this.company.id, { intents: this.intents })
        .then((response) => {
          this.$loading.finish();
          this.$auth.getLoginData();

          this.$store.commit("onboarding/nextStep");
        })
        .catch((error) => {
          this.$loading.finish();
        });
    },
    back() {
      this.$store.commit("onboarding/backStep");
    },
  },
};
</script>
